export const IMAGES = {
  heroBg: "/images/hero.jpg",
  laVilla: "https://images.unsplash.com/photo-1760067537116-de1f76fe8f95?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjB2aWxsYSUyMGludGVyaW9yJTIwd2FybSUyMGNvenklMjByZXNvcnQlMjByb29tfGVufDB8fHx8MTc4NzkyMDIxMXww&ixlib=rb-4.1.0&q=85",
  ilBoschetto: "https://images.unsplash.com/photo-1685800812421-3ef801b6182c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHw0fHx1bWJyaWElMjBsYW5kc2NhcGUlMjB2aW5leWFyZHMlMjBoaWxscyUyMG5hdHVyZSUyMHN1bmxpdHxlbnwwfHx8fDE3ODc5MjAxOTl8MA&ixlib=rb-4.1.0&q=85",
  suite: "https://images.unsplash.com/photo-1705765276125-f2539bc95b0f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjB2aWxsYSUyMGludGVyaW9yJTIwd2FybSUyMGNvenklMjByZXNvcnQlMjByb29tfGVufDB8fHx8MTc4NzkyMDIxMXww&ixlib=rb-4.1.0&q=85",
  couple: "https://images.unsplash.com/photo-1761839257647-df30867afd54?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxlbGRlcmx5JTIwY291cGxlJTIwc21pbGluZyUyMHdhcm10aCUyMGxpZmVzdHlsZSUyMG91dGRvb3JzfGVufDB8fHx8MTc4NzkyMDIxMXww&ixlib=rb-4.1.0&q=85",
  food: "https://images.unsplash.com/photo-1764397514690-82da4d4c40ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxtZWRpdGVycmFuZWFuJTIwb3JnYW5pYyUyMGZyZXNoJTIwaGVhbHRoeSUyMGRpc2glMjBmaW5lJTIwZGluaW5nfGVufDB8fHx8MTc4NzkyMDIxN3ww&ixlib=rb-4.1.0&q=85",
  nurse: "https://images.unsplash.com/photo-1765896387387-0538bc9f997e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxjYXJpbmclMjBudXJzZSUyMGhlbHBpbmclMjBzZW5pb3IlMjB3YXJtJTIwZ2VudGxlJTIwaGFuZHN8ZW58MHx8fHwxNzg3OTIwMjE3fDA&ixlib=rb-4.1.0&q=85",
  hands: "https://images.unsplash.com/photo-1544306430-4e3720a9a04a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHw0fHxjYXJpbmclMjBudXJzZSUyMGhlbHBpbmclMjBzZW5pb3IlMjB3YXJtJTIwZ2VudGxlJTIwaGFuZHN8ZW58MHx8fHwxNzg3OTIwMjE3fDA&ixlib=rb-4.1.0&q=85",
  villa1: "/images/villa/villa-1.jpg",
  villa2: "/images/villa/villa-2.jpg",
  villa3: "/images/villa/villa-3.jpg",
  villa4: "/images/villa/villa-4.jpg",
  villa5: "/images/villa/villa-5.jpg",
  villa6: "/images/villa/villa-6.jpg",
  villa7: "/images/villa/villa-7.jpg",
  villa8: "/images/villa/villa-8.jpg",
  villa9: "/images/villa/villa-9.jpg",
  boschetto1: "/images/boschetto/boschetto-1.jpg",
  boschetto2: "/images/boschetto/boschetto-2.jpg",
  boschetto3: "/images/boschetto/boschetto-3.jpg",
  suite1: "/images/suite/suite-1.jpg",
  suite2: "/images/suite/suite-2.jpg",
  suite3: "/images/suite/suite-3.jpg",
  suite4: "/images/suite/suite-4.jpg",
  suite5: "/images/suite/suite-5.jpg",
  chiSiamo: "/images/chi-siamo.jpg",
  cancello: "/images/cancello.jpg",
};

export const CONTACTS = {
  phoneDisplay: "+39 0763 600123",
  phoneHref: "tel:+390763600123",
  mobileDisplay: "+39 345 1234567",
  mobileHref: "tel:+393451234567",
  whatsapp: "https://wa.me/393451234567",
  email: "info@ortodellalongevita.it",
  address: "Via dei Colli 12, 05013 Castel Giorgio (TR), Umbria",
  mapsEmbed: "https://www.google.com/maps?q=Castel+Giorgio,+TR,+Italia&output=embed",
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const NAV_LINKS = [
  { id: "chi-siamo", label: "Chi Siamo" },
  { id: "strutture", label: "Le Strutture" },
  { id: "galleria", label: "Galleria" },
  { id: "servizi", label: "Servizi" },
  { id: "team", label: "Il Team" },
  { id: "contatti", label: "Contatti" },
  { id: "faq", label: "Domande Frequenti" },
];

export const MARQUEE_ITEMS = [
  "Serenità",
  "Benessere quotidiano",
  "Qualità della vita",
  "Cucina genuina",
  "Giardini rigogliosi",
  "Accoglienza familiare",
  "Castel Giorgio · Terni",
  "46 posti letto",
  "Dove il tempo ha ancora valore",
];

export const STRUCTURES = [
  {
    id: "la-villa",
    name: "La Villa",
    beds: 24,
    tagline: "Eleganza e socialità",
    desc: "La Villa offre un ambiente elegante e familiare, pensato per garantire il massimo comfort e una qualità della vita elevata.",
    image: IMAGES.villa1,
    features: ["Camere confortevoli", "Ampi spazi comuni", "Sale dedicate alla socializzazione", "Sala pranzo", "Giardini e aree esterne", "Ambiente luminoso e accogliente"],
  },
  {
    id: "il-boschetto",
    name: "Il Boschetto",
    beds: 17,
    tagline: "Quiete immersa nel verde",
    desc: "Il Boschetto è ideale per chi ricerca tranquillità e un contesto accogliente, mantenendo sempre elevati standard di assistenza e attenzione alla persona.",
    image: IMAGES.boschetto1,
    features: ["Ambiente tranquillo", "Struttura immersa nel verde", "Spazi comuni dedicati alla convivialità", "Atmosfera familiare"],
  },
  {
    id: "suite-dependance",
    name: "Suite Dependance",
    beds: 5,
    tagline: "Privacy e comfort esclusivo",
    desc: "Le Suite Dependance rappresentano la soluzione più esclusiva del complesso, pensata per chi desidera un ambiente più intimo e riservato.",
    image: IMAGES.suite3,
    features: ["Maggiore privacy", "Camere eleganti", "Ambiente riservato", "Comfort elevato"],
  },
];

export const SERVICES = [
  {
    icon: "HeartHandshake",
    title: "Assistenza alla Persona",
    items: ["Supporto nelle attività quotidiane", "Assistenza nelle esigenze personali", "Attenzione costante al benessere dell'ospite", "Monitoraggio delle necessità individuali"],
  },
  {
    icon: "UtensilsCrossed",
    title: "Alimentazione",
    items: ["Pasti preparati quotidianamente", "Menù equilibrati", "Attenzione alle esigenze alimentari personali"],
  },
  {
    icon: "Sparkles",
    title: "Attività Ricreative",
    items: ["Momenti di socializzazione", "Attività di gruppo", "Giochi e letture", "Feste, eventi e ricorrenze speciali"],
  },
  {
    icon: "Flower2",
    title: "Benessere e Vita Quotidiana",
    items: ["Passeggiate nei giardini", "Aree relax e spazi verdi", "Attività leggere per il mantenimento dell'autonomia"],
  },
];

export const TEAM = [
  { icon: "Briefcase", dept: "Direzione", desc: "Responsabilità organizzative e gestionali del complesso, al servizio di ospiti e famiglie." },
  { icon: "ClipboardList", dept: "Coordinamento", desc: "Punto di riferimento per ospiti, familiari e personale, ogni giorno." },
  { icon: "Users", dept: "Area Assistenziale", desc: "Professionisti che accompagnano gli ospiti nelle attività quotidiane garantendo presenza, ascolto e supporto." },
  { icon: "Stethoscope", dept: "Area Sanitaria", desc: "Collabora al monitoraggio dello stato di salute e alla gestione delle indicazioni terapeutiche prescritte." },
  { icon: "ChefHat", dept: "Cucina e Ristorazione", desc: "Preparazione quotidiana dei pasti con attenzione alla qualità e alle esigenze individuali." },
  { icon: "Wrench", dept: "Manutenzione e Servizi", desc: "Cura degli ambienti interni ed esterni, per garantire ordine, sicurezza e comfort." },
];

export const GALLERY_CATS = ["Tutti", "La Villa", "Il Boschetto", "Suite Dependance"];

export const GALLERY = [
  { src: IMAGES.villa1, cat: "La Villa", label: "La facciata e il portico d'ingresso" },
  { src: IMAGES.villa2, cat: "La Villa", label: "Il piazzale in pietra" },
  { src: IMAGES.villa3, cat: "La Villa", label: "La Villa vista dal parco" },
  { src: IMAGES.villa4, cat: "La Villa", label: "Il viale e il vigneto al tramonto" },
  { src: IMAGES.villa5, cat: "La Villa", label: "Il giardino con gli ulivi" },
  { src: IMAGES.villa6, cat: "La Villa", label: "Il corridoio con le volte in mattoni" },
  { src: IMAGES.villa7, cat: "La Villa", label: "Una camera doppia accogliente" },
  { src: IMAGES.villa8, cat: "La Villa", label: "La scalinata d'ingresso" },
  { src: IMAGES.cancello, cat: "La Villa", label: "Il cancello d'ingresso" },
  { src: IMAGES.villa9, cat: "La Villa", label: "La Villa e il vigneto in piena estate" },
  { src: IMAGES.boschetto1, cat: "Il Boschetto", label: "L'ingresso con il portico" },
  { src: IMAGES.boschetto3, cat: "Il Boschetto", label: "Il piazzale e la facciata laterale" },
  { src: IMAGES.boschetto2, cat: "Il Boschetto", label: "Il salone comune" },
  { src: IMAGES.suite3, cat: "Suite Dependance", label: "La Dependance vista dal giardino" },
  { src: IMAGES.suite1, cat: "Suite Dependance", label: "La Dependance immersa tra le rose" },
  { src: IMAGES.suite2, cat: "Suite Dependance", label: "Il vialetto in pietra verso le Suite" },
  { src: IMAGES.suite4, cat: "Suite Dependance", label: "Gli esterni delle Suite nel verde" },
  { src: IMAGES.suite5, cat: "Suite Dependance", label: "Il soggiorno privato delle Suite" },
];

export const STEPS = [
  { title: "Primo contatto", desc: "Una telefonata o una richiesta tramite il sito: siamo qui per ascoltarvi." },
  { title: "Visita della struttura", desc: "Un appuntamento dedicato alla famiglia, per conoscere gli spazi e le persone." },
  { title: "Colloquio conoscitivo", desc: "Valutiamo insieme le esigenze dell'ospite, con attenzione e riservatezza." },
  { title: "Scelta della soluzione più adatta", desc: "Individuiamo insieme la struttura più indicata tra Villa, Boschetto e Suite." },
  { title: "Ingresso in struttura", desc: "Un'accoglienza personalizzata, perché ogni inizio sia sereno." },
];

export const FAQS = [
  { q: "È possibile visitare la struttura?", a: "Sì, previo appuntamento. Potete prenotare una visita guidata tramite il modulo dedicato o telefonicamente: saremo lieti di accogliervi e mostrarvi gli spazi." },
  { q: "I familiari possono effettuare visite?", a: "Sì, secondo le modalità previste dalla struttura. Il legame con la famiglia è per noi parte fondamentale del benessere dell'ospite." },
  { q: "Le camere possono essere personalizzate?", a: "Sì, compatibilmente con gli spazi disponibili. Fotografie, piccoli arredi e oggetti cari aiutano a sentirsi davvero a casa." },
  { q: "Sono presenti spazi esterni?", a: "Sì, tutte le strutture dispongono di ampi giardini e aree verdi, curati e accessibili per passeggiate e momenti di relax all'aperto." },
  { q: "Come richiedere informazioni?", a: "Telefonicamente, via WhatsApp oppure tramite il modulo contatti presente in questa pagina. Rispondiamo sempre con attenzione e tempestività." },
];

export const REVIEWS = [
  { text: "Dal primo giorno ci siamo sentiti accolti come in famiglia. Nostra madre è serena, seguita con attenzione e sorride di nuovo. Non potremmo chiedere di più.", author: "Famiglia Benedetti", role: "Figlia di un'ospite de La Villa" },
  { text: "Il Boschetto è un luogo speciale: silenzio, verde e persone che si prendono cura di nostro padre con una delicatezza rara. Le visite sono sempre un piacere.", author: "Marco T.", role: "Figlio di un ospite de Il Boschetto" },
  { text: "Ambiente elegante e riservato, personale attento e cucina davvero buona. La Suite Dependance ha reso questo passaggio di vita molto più sereno per tutti noi.", author: "Famiglia Ricci", role: "Familiari di un'ospite delle Suite" },
];

export const CHAPTERS = [
  { num: "01", title: "La persona al centro", text: "Ogni ospite è unico e merita attenzione, rispetto e cura. Ogni giornata è costruita intorno ai suoi ritmi, ai suoi desideri e alle sue abitudini." },
  { num: "02", title: "L'ambiente che accoglie", text: "Crediamo che il benessere non dipenda solamente dall'assistenza ricevuta, ma anche dall'ambiente in cui si vive, dalle relazioni umane e dalla serenità quotidiana." },
  { num: "03", title: "Come a casa propria", text: "Per questo abbiamo creato strutture immerse nel verde, accoglienti e progettate per far sentire ogni ospite come a casa propria." },
];
